export default __webpack_public_path__ + "static/media/Dzintra.0da99a6e.png";